// auth
export const AUTH__CHECK = 'AUTH__CHECK'
export const AUTH__FORGOT = 'AUTH__FORGOT'
export const AUTH__INVITATION = 'AUTH__INVITATION'
export const AUTH__LOGIN = 'AUTH__LOGIN'
export const AUTH__LOGOUT = 'AUTH__LOGOUT'
export const AUTH__RESET = 'AUTH__RESET'
export const AUTH__RECOVER = 'AUTH__RECOVER'
export const AUTH__VERIFY_CODE = 'AUTH__VERIFY_CODE'
export const AUTH__REGISTER_CONFIRM = 'AUTH__REGISTER_CONFIRM'
export const AUTH__REGISTER_REQUEST = 'AUTH__REGISTER_REQUEST'

// scripts
export const SCRIPTS__FETCH = 'SCRIPTS__FETCH'
export const SCRIPTS__FETCH_CARDS = 'SCRIPTS__FETCH_CARDS'
export const SCRIPTS__FETCH_ONE = 'SCRIPTS__FETCH_ONE'
export const SCRIPTS__CREATE = 'SCRIPTS__CREATE'
export const SCRIPTS__UPDATE = 'SCRIPTS__UPDATE'
export const SCRIPTS__CREATE_OPTION = 'SCRIPTS__CREATE_OPTION'
export const SCRIPTS__UPDATE_OPTION = 'SCRIPTS__UPDATE_OPTION'
export const SCRIPTS__REMOVE_OPTION = 'SCRIPTS__REMOVE_OPTION'
export const SCRIPTS__REMOVE_VARIANT = 'SCRIPTS__REMOVE_VARIANT'
export const SCRIPTS__MAKE_ACTION = 'SCRIPTS__MAKE_ACTION'
export const SCRIPTS__DELETE_ITEM = 'SCRIPTS__DELETE_ITEM'
export const SCRIPTS__PUBLISH_ITEM = 'SCRIPTS__PUBLISH_ITEM'
export const SCRIPTS__STEP_CARD = 'SCRIPTS__STEP_CARD'

// settings
export const SETTINGS__INIT = 'SETTINGS__INIT'

//user-filters
export const SAVEDFILTERS__LOAD = 'SAVEDFILTERS__LOAD'
export const SAVEDFILTERS__LOAD_ONE = 'SAVEDFILTERS__LOAD_ONE'
export const SAVEDFILTERS__CREATE = 'SAVEDFILTERS__CREATE'
export const SAVEDFILTERS__UPDATE = 'SAVEDFILTERS__UPDATE'
export const SAVEDFILTERS__DELETE = 'SAVEDFILTERS__DELETE'

export const ALL_PRODUCTS = 'ALL_PRODUCTS'